import React from 'react';
import {ServiceBase} from '../ServiceBase';
import {ICheckboxData, IGamePopupService} from './game-popup.service.interface';
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {GamePopupComponent} from "../../components/game-popup/game-popup.component";
import {ITranslationService} from "../translation/translation.service.interface";
import {computed} from "mobx";
import {GamesMap} from "../games/games.service.interface";
import {Check} from "@sparkware/app-utils";
import {OnShowGamePopupCallbackParams} from "../sdk/sdk-events";
import {GameInfo} from "../games/game-info";

export class GamePopupService extends ServiceBase implements IGamePopupService {
    private translationService: ITranslationService;

    constructor(services: IServiceFactoryExtended) {
        super(services);

        this.translationService = this.services.translation;

        this.services.sdk.events.onShowGamePopup((args: OnShowGamePopupCallbackParams) => {
            this.openAfterLoginGamePopup(args);
        });
    }

    @computed
    private get _gameMap(): GamesMap{
        return this.services.games.gamesMap;
    }

    private getMenuItems() {
        return this.services.configuration.data.gamePopup.menuLinks;
    }

    private async openPopup(params: {
        popupTitleText: string,
        gameInfo: GameInfo,
        subTitleText: string,
        descriptionText: string,
        menuItems: string[],
        onCloseHandler?: () => void,
        onClosedByXButton?: () => void,
        onClickNotNowButton?: () => void
        onClickPlay?: () => void,
        checkboxData?: ICheckboxData,
        useSquareIcons?: boolean
    }) {
        this.services.dialog.showModal(dialogHandler =>
            <GamePopupComponent
                dialogHandler={dialogHandler}
                gameInfo={params.gameInfo}
                subTitle={params.subTitleText}
                description={params.descriptionText}
                menuItems={params.menuItems}
                onClickNotNowButton={params.onClickNotNowButton}
                onClickPlay={params.onClickPlay}
                checkboxData={params.checkboxData}
                useSquareIcons={params.useSquareIcons}
            />, {
                title: params.popupTitleText,
                forceTransparentBackground: true,
                disableFullscreenMobile: true,
                forceCentralization: true,
                mobileCenterHeader: true,
                isHighPriority:  true,
                onClosedByXButton: params.onClosedByXButton,
                onClosed: params.onCloseHandler,
                shouldBeClosedOnlyByUser: true,
                noDefaultContentPadding: true
            }
        );
    }

    private async openAfterLoginGamePopup({gameType, gamePopupApprovedCallback}: OnShowGamePopupCallbackParams){
        const welcomeTitleText = this.translationService.translate("GAME_POPUP_TITLE");
        const suggestedGameText = this.translationService.translate("GAME_POPUP_SUB_TITLE");
        const yourActivityText = this.translationService.translate("GAME_POPUP_DESCRIPTION");

        let gameInfo: GameInfo;

        if(gameType) {
            if (Check.isEmpty(this._gameMap)) {
                gameInfo = await this.services.games.getGameInfo(gameType);
            } else {
                gameInfo = this._gameMap[gameType];
            }
        }

        this.openPopup({
            popupTitleText: welcomeTitleText,
            subTitleText: suggestedGameText,
            descriptionText: yourActivityText,
            gameInfo: gameInfo,
            menuItems: this.getMenuItems(),
            onCloseHandler: () => {
                if(Check.isFunction(gamePopupApprovedCallback)) {
                    gamePopupApprovedCallback();
                }
            }
        });
    }

    async showSuggestedGame(gameType: number, title: string, subTitle: string, onCloseHandler?: () => void, onClosedByXButton?: () => void, onClickNotNowButton?: () => void, onClickPlay?: () => void, checkboxData?: ICheckboxData, useSquareIcons?: boolean): Promise<void> {
        let gameInfo: GameInfo;

        if(gameType) {
            if (Check.isEmpty(this._gameMap)) {
                gameInfo = await this.services.games.getGameInfo(gameType);
            } else {
                gameInfo = this._gameMap[gameType];
            }
        }

        this.openPopup({
            popupTitleText: title,
            subTitleText: subTitle,
            descriptionText: "",
            gameInfo: gameInfo,
            menuItems: null,
            onCloseHandler: () => {
                onCloseHandler && onCloseHandler();
            },
            onClickNotNowButton: () => {
                onClickNotNowButton && onClickNotNowButton();
            },
            onClickPlay: () => {
                onClickPlay && onClickPlay();
            },
            checkboxData: checkboxData,
            onClosedByXButton: onClosedByXButton,
            useSquareIcons: useSquareIcons
        });
    }

}
